<template>
  <div>
    <a-modal
        v-drag-modal
        wrap-class-name="custom-modal-wrap" v-model="localVisible" :confirmLoading="loading" :maskClosable="false" @cancel="cancel" @ok="confirm" :destroyOnClose="true">
      <div slot="title">{{ form.id ? "编辑" : "新增" }}</div>
        <div style="max-height: 65vh; overflow-y: auto;border: 1px solid #277fd0 ; overflow-x: hidden;padding: 10px;margin: -10px">
        <a-form-model ref="form" :model="form" :rules="rules" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
          <a-form-model-item prop="product_id" label="商品">
            <a-select
                v-model="form.product_id"
                :show-search="true"
                :filterOption="false"
                @change="changeGoods"
                @search="handleProductSearch"
                @popupScroll="handleProductPopupScroll"
            >
              <a-select-option
                  v-for="val in filteredProductList"
                  :key="val.goods.id"
                  :value="val.goods.id">
                {{ val.product_name }}
              </a-select-option>
              <a-select-option v-if="isLoadingMoreProducts" disabled key="loading">
                <a-spin size="small" /> 加载中...
              </a-select-option>
              <a-select-option v-if="!hasMoreProducts && allLoadedProducts.length > 0" disabled key="no-more">
                已加载全部 {{ productTotalCount }} 条数据
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item prop="date" label="批次">
            <a-select v-model="form.date" style="width: 100%" @change="changeBatch">
              <a-select-option
                      v-for="(val, index) in BatchListInfo.pici"
                      :key="val.batch"
                      :value="val.batch"
              >
                {{ val.batch }}
              </a-select-option>
            </a-select>
          </a-form-model-item>

          <a-form-model-item prop="number" label="编号">
            <a-select v-model="form.number" style="width: 100%">
              <a-select-option
                      v-for="val in numberList"
                      :key="val"
                      :value="val"
              >
                {{ val }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item prop="title" label="标题">
            <a-select v-model="form.title" disabled @change="onChange">
              <a-select-option v-for="(val, index) in titleList" :key="index" :value="val.title">
                {{ val.title }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item prop="result" label="描述" v-if="form.title">
            <a-select mode="tags" v-model="form.result">
              <a-select-option v-for="(val, index) in results" :key="index" :value="val.value">
                {{ val.label }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item prop="image" label="上传附件">
            <Upload :ID_image="safeFileList" :count="3" @handleChange="onFileChange" />
          </a-form-model-item>
        </a-form-model>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { traceabilityAdd, traceabilityEdit, fromProductList, tracePici } from "@/api/from";
import Upload from '../../../components/Upload/index'

export default {
  name: "FormModal",
  components: { Upload },
  props: ["visible", "form", "reNumber", "BatchList", "clientsClassificationOptions"],
  model: { prop: "visible", event: "cancel" },
  computed: {
    filteredProductList() {
      let list = this.allLoadedProducts;
      if (this.productSearchKeyword) {
        const keyword = this.productSearchKeyword.toLowerCase();
        list = list.filter(item => {
          const nameStr = (item.product_name || '').toLowerCase();
          const idStr = String(item.goods?.id || '').toLowerCase();
          return nameStr.includes(keyword) || idStr.includes(keyword);
        });
      }
      return list;
    },
    results() {
      if (this.form.title) {
        const data = this.titleList.filter((item) => item.title === this.form.title);
        if (data.length > 0) {
          return data[0].describe.map((item) => ({ label: item, value: item }));
        }
        return [];
      }
      return [];
    },
    safeFileList() {
      const img = this.form.image;
      if (!Array.isArray(img) || img.length === 0) return [];
      if (typeof img[0] === 'string') {
        return img.map((url, i) => ({
          uid: `-${i}`,
          name: url.split('/').pop() || `file${i}`,
          status: 'done',
          url,
        }));
      }
      return img;
    }
  },
  data() {
    return {
      localVisible: this.visible,
      numberList: [],
      BatchListInfo: [],
      allLoadedProducts: [],
      productTotalCount: 0,
      hasMoreProducts: true,
      isLoadingMoreProducts: false,
      productSearchKeyword: '',
      productCurrentPage: 1,
      productPageSize: 50,
      titleList: [
        { title: '原料验收', describe: ['原料索证齐全', '原料验收合格'] },
        { title: '生产投料', describe: ['根据订单生产'] },
        { title: '半成品检测', describe: ['半成品检测合格'] },
        { title: '成品检测', describe: ['成品检测合格'] },
        { title: '成品出库', describe: ['成品出库检测合格'] },
      ],
      rules: {
        product_id: [{ required: true, message: "请选择商品", trigger: "change" }],
        date: [{ required: true, message: "请选择批次", trigger: "change" }],
        number: [{ required: true, message: "请输入编号", trigger: "blur" }],
        title: [{ required: true, message: "请选择标题", trigger: "change" }],
        result: [{ required: true, message: "请选择描述", trigger: "change" }],
      },
      loading: false,
    };
  },
  watch: {
    visible(v) { this.localVisible = v; },
    'BatchList': {
      handler() { this.BatchListInfo = this.BatchList; },
      deep: true
    },
    'reNumber': {
      handler() { this.numberList = this.reNumber; },
      deep: true
    }
  },
  created() {
    this.loadMoreProducts(false);
  },
  methods: {
    loadMoreProducts(isLoadMore = false) {
      if (!isLoadMore) {
        this.productCurrentPage = 1;
        this.allLoadedProducts = [];
      }
      this.isLoadingMoreProducts = true;
      fromProductList({ page: this.productCurrentPage, page_size: this.productPageSize }).then(res => {
        const newList = res.data || [];
        this.productTotalCount = res.count || 0;
        if (isLoadMore) {
          this.allLoadedProducts = [...this.allLoadedProducts, ...newList];
        } else {
          this.allLoadedProducts = newList;
        }
        this.hasMoreProducts = this.allLoadedProducts.length < this.productTotalCount;
      }).finally(() => {
        this.isLoadingMoreProducts = false;
      });
    },
    handleProductSearch(value) {
      this.productSearchKeyword = value;
    },
    handleProductPopupScroll(e) {
      const { target } = e;
      if (target.scrollHeight - target.scrollTop <= target.clientHeight + 10 && this.hasMoreProducts && !this.isLoadingMoreProducts) {
        this.productCurrentPage++;
        this.loadMoreProducts(true);
      }
    },
    async changeBatch(val) {
      delete this.form.number;
      this.numberList = this.BatchList.pici.filter(obj => obj.batch == val).map(obj => obj.number).flat();
    },
    async changeGoods(val) {
      let res1 = await tracePici({ product_id: val });
      delete this.form.date;
      delete this.form.number;
      this.BatchListInfo = res1.data;
      this.BatchList.pici = res1.data.pici;
    },
    onChange() {
      this.form.result = [];
    },
    onFileChange(fileList) {
      this.$set(this.form, 'image', fileList);
    },
    confirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let form = this.form;
          this.loading = true;
          let func = form.id ? traceabilityEdit : traceabilityAdd;
          form.image = (form.image || []).filter(item => item.status === 'done')
            .map(item => item.url || item.response.data.file_url);
          func(form)
            .then(() => {
              this.$message.success(form.id ? "修改成功" : "新增成功");
              this.$emit(form.id ? "update" : "create");
              this.cancel();
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    cancel() {
      this.$emit("cancel", false);
    },
  },
};
</script>

<style scoped></style>
